import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import Sidebar from 'components/Sidebar'

const NavigationWrapper = (props) => {
    const routesToRestrict = ['/login', '/', '/signup']
    const [isPublic, setPublicMode] = useState(false)

    // On initial mount check routes to restrict
    useEffect(() => {
        if (routesToRestrict.includes(props.location.pathname)) {
            setPublicMode(true)
        } else {
            setPublicMode(false)
        }
    }, [])

    //   // Checks if route is changed and if its public
    //   useEffect(() => {
    //     console.log('on CDU navigation');
    //     if (routesToRestrict.includes(props.location.pathname)) {
    //       setPublicMode(true);
    //     } else {
    //       setPublicMode(false);
    //     }
    //   }, [props.location.pathname]);

    return (
        <React.Fragment>
            <Sidebar isPublic={isPublic} />
        </React.Fragment>
    )
}

export default withRouter(NavigationWrapper)
